import { PAYMENT_METHODS } from "src/constants/payments"

const PAYMENT_TYPES = {
    amex: PAYMENT_METHODS.amex,
    consumo_interno: PAYMENT_METHODS.consumoInterno,
    cortesia: PAYMENT_METHODS.cortesia,
    deposito_o_transferencia: PAYMENT_METHODS.depositoOTransferencia,
    efectivo: PAYMENT_METHODS.efectivo,
    visa_o_mastercard: PAYMENT_METHODS.visaOMasterCard,
    love_points: PAYMENT_METHODS.lovePoints,
    mixto: { value: "mixto", label: "Mixto" },
}

export const getPayments = (key: string) => {
    let value = ""
    const items = key?.split(", ")
    const clear = [...new Set([...items])]
    clear.forEach((i)=>{
        const pago = i.split(" / ")
        const label = pago?.[1] ? pago?.[1]  : pago?.[0] ? PAYMENT_TYPES?.[pago?.[0]]?.label : ""
        value = `${value}${label ? ` ${label}` : ""}`
    })
            
    return value
}